// Product ID to single Variant ID mapping
let tangent_selected_product_map;

const default_addToCartText = "Add To Cart";
const default_addedToCartText = "Added to Cart!";
const default_add_all_to_cart_text = "Add All to Cart";
const out_of_stock_text = "Out of Stock";
const no_products_found_text ="No products found. Please retry!";

let tangent_client_domain_currency;

let sections_add_to_cart_map={};

const attributeStyle = {
    "Dryness": {color: '#F4B3CE', fillColor: '#F4B3CE22'}, // pink
    "Shine": {color: '#799FCB', fillColor: '#799FCB22'}, // blue
    "Flyaways": {color: '#9884C7', fillColor: '#9884C722'}, // purple
    "Frizz": {color: '#FAEFD7', fillColor: '#FAEFD722'}, // yellow
    "Split Ends": {color: '#68D1C5', fillColor: '#68D1C522'} // green
}

const hairThinningInfo = [
  "Your strands are looking strong, full and thriving. Keep riding the momentum and stay consistent with your routine.",
  "You're noticing the first signs of thinning - minor but worth catching early. With a little targeted support, you're set to stay ahead.",
  "This is more than just shedding - you're entering the zone where volume has started to shift. Time to step up with focused repair and shedding care.",
  "Thinning has clearly taken hold and your roots are begging for attention. Let's switch into recovery mode and bring in heavy-duty support for fullness.",
  "Your hair is in a full-on comeback condition. Scalp, strand and density all need extra love - let's go all in on restoring what's been lost."
]

const heroProductText = {
  Dryness: "Spotted dryness? <a href='#' target='_blank' class='tooltip-product-link'>Product 1</a> and <a href='#' target='_blank' class='tooltip-product-link'>Product 2</a> to the rescue!",
  Frizz:  "Spotted flyaways? <a href='#' target='_blank' class='tooltip-product-link'>Product 3</a> to the rescue!",
  Shine: "Spotted shine? <a href='#' target='_blank' class='tooltip-product-link'>Product 4</a> to the rescue!",
  "Split Ends": "Spotted split ends? <a href='#' target='_blank' class='tooltip-product-link'>Product 5</a> and <a href='#' target='_blank' class='tooltip-product-link'>Product 6</a> to the rescue!"
}

const default_selfie_image_url = "https://cdn.shopify.com/s/files/1/0058/0717/7774/files/MK09896_fc92971f-3579-4142-8de0-c6d05893dcc5.jpg?v=1778831696";
const default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

const tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
const tangent_client_domain_url = window.location.origin;
const tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 

const condition_img_map = {
    0: "https://file.tangent.ai/quiz-content/merchants/self-serve-app-store/image/6724274927437921-exceptional.png",
    1: "https://file.tangent.ai/quiz-content/merchants/self-serve-app-store/image/07050205263636644-healthy.png",    
    2: "https://file.tangent.ai/quiz-content/merchants/self-serve-app-store/image/08533771892091924-mild.png",    
    3: "https://file.tangent.ai/quiz-content/merchants/self-serve-app-store/image/4590586797331133-moderate.png",    
    4: "https://file.tangent.ai/quiz-content/merchants/self-serve-app-store/image/1892010233052941-significant.png"
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", (event) => {
    onLoadFunction();
  });
} else {
  onLoadFunction();
}

function onLoadFunction(){
  var tangent_response_id = getClientResponseId()
  checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  let tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    const checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
        setElementDisplay("#tangent-main-loader","none");
        callHairDamageApi(response.selfie_id, response);
        showProductsRecommendation(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}


function callHairDamageApi(selfie_id, recommendation_data){
  if(selfie_id){
    const url = `https://service.tangent.ai/shopify/upload-selfie?selfie_id=${selfie_id}&user=mango`

    var settings = {
        "url": url,
        "method": "GET",
        "headers": {
            "Content-Type": "application/json",
        },
    };
      
    $.ajax(settings).done(function (response) {
      showLoader(true);

      setSelfieImage(response.url);
      if (response.selfie_record?.[0]?.hairdamage) {
        const hairDamage = response.selfie_record[0].hairdamage;

        // Set hair damage image if score exists
        const score = hairDamage?.damage?.score ?? null;
        if (score !== null) {
          setHairDamageImage(score);
        }

        // Set loader with health score, defaulting to 0 if missing
        // loaderSet(Math.round(hairDamage?.health_score ?? 0));

        // Draw chart with hair damage data
        drawChart(hairDamage);

        setElementDisplay("#analysis_container","flex");
      }

      const hair_score = calculateHairScore(recommendation_data.tags);
      loaderSet(hair_score);
      showLoader(false);

      loadElementsAfterData();
    }).fail(function(data){
      console.log("data fetch error occured : ",data)
    });;
  }
  else{
    const hair_score = calculateHairScore(recommendation_data.tags);
    loaderSet(hair_score);
    const charContainer = document.getElementById("analysis_container");
    charContainer.remove();
    const image_container = document.getElementById("image_container");
    image_container.innerHTML = `<img src="${default_selfie_image_url}" class="default_selfie_image">`;
  }
}

function calculateHairScore(tags) {
  const penalties = {
    hairType: {
      oily_prone: 8,
      balanced_prone: 0,
      mixed_prone: 5,
      dry_prone: 8,
    },
    scalp: {
      scalp_concern_balanced: 0,
      scalp_concern_dry: 10,
      scalp_concern_oily: 10,
      scalp_concern_buildup: 12,
      scalp_concern_flaky_itchy: 15,
      scalp_concern_sensitive: 15,
    },
    strand: {
      strand_concern_happy: 0,
      strand_concern_frizziness: 8,
      strand_concern_hair_loss: 15,
      strand_concern_dry: 10,
      strand_concern_breakage: 12,
      strand_concern_dull: 8,
    }
  };

  let totalPenalty = 0;

  Object.values(penalties).forEach(category => {
    const matched = Object.entries(category)
      .filter(([key]) => tags.includes(key))
      .map(([_, val]) => val);

    const penalty = matched.length ? Math.max(...matched) : 0;
    totalPenalty += penalty;
  });

  let score = 100 - totalPenalty;

  // ✅ Enforce range >60 and <95
  score = Math.max(61, Math.min(94, score));

  return score;
}

function loadElementsAfterData(){
  document.querySelectorAll(`.load-on-data`).forEach(el => {
    el.style.display="flex";
  });
}

function setElementDisplay(selector, style){
  const element = document.querySelector(selector);
  if (element) {
    element.style.display=style;
  }
}

function loaderSet(percent){
    document.querySelector(".hair-score-hero-section").style.display = "flex";
    const progressValue = document.querySelector(".percentage");
    let startValue = 0,
        endValue = percent,
        speed = 10;

    const progress = setInterval(() => {
        startValue++;
        progressValue.textContent = `${startValue}%`;

        if (startValue === endValue) {
            clearInterval(progress);
        }
    }, speed);
}

function getAttributeScore(attributeMap, attributeName, minimum=0.2){
    if(attributeMap.hasOwnProperty(attributeName)){
        return Math.max(attributeMap[attributeName].score, minimum); 
    }
    return 0;
}
function drawAttributesOnCanvas(canvas, attributeMap, attributeName){
    if(!attributeMap.hasOwnProperty(attributeName)){
        return;
    }

    for(let l=0; l < attributeMap[attributeName].loc.length; l++){
        const box = attributeMap[attributeName].loc[l].box;
        selfie.drawRectangleOnCanvas(canvas, [
            {_x: box[0][0],_y: box[0][1]},
            {_x: box[1][0], _y: box[1][1]}
        ], attributeStyle[attributeName]);
    }
}

function drawAttributesUsingHtml(attributeMap, attributeName){
    if(!attributeMap.hasOwnProperty(attributeName)){
        return;
    }

    var containerDiv = document.getElementById("attributes-overlay-container");

    for(let l=0; l < attributeMap[attributeName].loc.length; l++){
        const box = attributeMap[attributeName].loc[l].box;
        selfie.drawRectangleUsingHtml(containerDiv, attributeName, box, handleHairAttributeClick)
    }
}

function translateShineToDullnessScore(shineScore){
    let dullnessScore = 0;
    if(shineScore == 0){
        dullnessScore = 3;
    } else{
        dullnessScore = 0.5*(4 - shineScore);
    }
    return dullnessScore;
}

function handleTangentModalClose(){
    let tooltip = document.querySelector(".tangent-attribute-tooltip-container");
    tooltip.setAttribute("style", "display: none;")
}

function handleHairAttributeClick(event, attribute) {
  const div = event.currentTarget; 
  if (div) {
    const rect = div.getBoundingClientRect();
    const tooltip = document.querySelector(".tangent-attribute-tooltip-container");
    const pointerElement = document.querySelector(".tangent-tooltip-pointer");
    const attributeElement = document.querySelector(".tangent-attribute");

    // Set attribute text
    attributeElement.innerHTML = getAttributeText(attribute);
    
    const tooltipWidth = 300; // fixed width from CSS
    const arrowDiagonalHalf = 8.5;
    const tooltipHeight = 50; // fixed height from CSS
    const arrowOffsetY = tooltipHeight + arrowDiagonalHalf;

    // Calculate initial position
    let leftPosition = rect.left;
    const topPosition = rect.top - arrowOffsetY;

    // Check if tooltip overflows to the right
    if (leftPosition + tooltipWidth > window.innerWidth) {
      leftPosition = window.innerWidth - tooltipWidth - 20; // 20px padding from edge
    }

    // Check if tooltip overflows to the left
    if (leftPosition < 0) {
      leftPosition = 10;
    }

    tooltip.setAttribute(
      "style",
      `display: block; top: ${topPosition}px; left: ${leftPosition}px;`
    );

    // Arrow position (center of origin box, adjusted if tooltip shifted)
    let pointerPosition = rect.left + rect.width / 2 - leftPosition - 10;
    pointerElement.setAttribute("style", `left: ${pointerPosition}px;`);
  }
}

const getAttributeText = (attributeName) => {
  return heroProductText[attributeName];
}

function drawChart(params) {
    var attr = params.attributes;
    var attr_list = [];

    selfie.init().then(() => {
        showLoader(false);
        if(selfie.imageWidth<300){
            setCanvasSize(selfie.imageHeight,selfie.imageWidth);
        }
        else{
            setCanvasSize(selfie.imageHeight,"100%");
        }
        const attributeNames = ["Dryness", "Frizz", "Flyaways", "Shine", "Split Ends"]
        for (const attributeName of attributeNames){
            if(attributeName == "Shine"){
                attr_list.push({
                    "x": "Dullness",
                    "value": translateShineToDullnessScore(getAttributeScore(attr, attributeName))
                });
            } else if(attributeName == "Flyaways"){
                attr_list.push({
                    "x": "Frizz",
                    "value": getAttributeScore(attr, attributeName)
                });
            }else {
                attr_list.push({
                    "x": attributeName,
                    "value": getAttributeScore(attr, attributeName)
                });
            }
            let updatedAttributeName = attributeName == "Flyaways" ? "Frizz" : attributeName;
            let updatedAttributes = moveFlyawaysToFrizz(attr);
            // drawAttributesOnCanvas(canvas, attr, attributeName)
            drawAttributesUsingHtml(updatedAttributes, updatedAttributeName, handleHairAttributeClick)
        }

        attr_list.push({
            "x": "Damage",
            "value": getAttributeScore(params, "damage")
        });
        setElementDisplay("#chart-loader","none");
        // create a chart and keep max value for frizz
        let withMaxFrizzValue = processHairData(attr_list)
        drawRadarChart(withMaxFrizzValue)

        
        // const recommendation = getRecommendedConcern(params);

    }).catch((error) => {
        console.log("Error in loading model "+error);
        showLoader(false);
        console.log(error.stack);
    });

}

function moveFlyawaysToFrizz(data) {
  if (!data.Flyaways) return data; // nothing to do

  if (data.Frizz) {
    // If Frizz exists, append Flyaways loc
    data.Frizz.loc = [...data.Frizz.loc, ...data.Flyaways.loc];
    // Optionally, you can decide which score to keep. Here I keep max.
    data.Frizz.score = Math.max(data.Frizz.score, data.Flyaways.score);
  } else {
    // If Frizz doesn't exist, create it
    data.Frizz = {
      loc: [...data.Flyaways.loc],
      score: data.Flyaways.score
    };
  }

  // Remove Flyaways
  delete data.Flyaways;

  return data;
}

function processHairData(data) {
  // const hairThinningHeader = document.querySelector(".hair-thinning-info");
  let maxFrizz = null;
  let damage = 0, splitEnds = 0, dryness = 0;

  // Process items
  data.forEach(item => {
    if (item.x === "Frizz") {
      if (!maxFrizz || item.value > maxFrizz.value) {
        maxFrizz = item;
      }
    }
    if (item.x === "Damage") damage = item.value;
    if (item.x === "Split Ends") splitEnds = item.value;
    if (item.x === "Dryness") dryness = item.value;
  });

  // Calculate Thinning score
  const thinningScore = Math.round(0.5 * damage + 0.3 * splitEnds + 0.2 * dryness);

  // Build new array
  const result = [
    ...data.filter(item => item.x !== "Frizz"),
    ...(maxFrizz ? [maxFrizz] : []),
    { x: "Thinning", value: thinningScore }
  ];

  // hairThinningHeader.innerHTML = hairThinningInfo[thinningScore];
  return result;
}

function showLoader(show) {
  const $loader = $('#tangent-selfie-loader');
  if (show) {
    $loader
      .addClass('show-loader')
      .css('display', 'flex');
  } else {
    $loader
      .removeClass('show-loader')
      .css('display', 'none');
  }
}

function setCanvasSize(height, width) {
  const formatSize = (value) => {
    if (typeof value === "number") return `${value}px`;

    const stringValue = String(value).trim();

    // If already has unit like px, %, vw, vh, rem, etc.
    if (/[\d.]+(px|%|vw|vh|rem|em)$/i.test(stringValue)) {
      return stringValue;
    }

    // Default to px
    return `${stringValue}px`;
  };

  const sizeStyle = `height: ${formatSize(height)}; width: ${formatSize(width)};`;

  canvas.setAttribute("style", sizeStyle);
  overlays_container_div.setAttribute("style", sizeStyle);
}

function setHairDamageImage(damage_score) {
  const img = document.getElementById("hair_damage_img");
  const src = condition_img_map?.[damage_score];

  if (!img) return;

  if (src) {
    img.src = src;
  } else {
    console.warn(`No image found for damage_score: ${damage_score}`);
  }
}

function setSelfieImage(url) {
  const img = document.getElementById("selfie_img");
  if (!img || !url) return;

  img.src = url;
}

function drawRadarChart(list){
    var chart = anychart.radar();

    var interactivity = chart.interactivity();
    interactivity.hoverMode("bySpot");
    interactivity.spotRadius(0);

    chart.tooltip(false);

    // Create area series
    var series = chart.area(list);

    // Change color (fill + stroke)
    series.fill("rgba(255, 99, 132, 0.4)");  // fill color
    series.stroke("2 #6c2f5a");              // border color

    chart.yScale().ticks().interval(1);
    chart.yScale().minimum(0);
    chart.yScale().maximum(4);

    var labels = chart.yAxis().labels();
    labels.enabled(false);

    chart.container("graph_container");
    chart.draw();
}

function getHairType(hairTypesProbabilityDistribution){
    const hairType = Object.keys(hairTypesProbabilityDistribution).reduce(
        (a, b) => hairTypesProbabilityDistribution[a] > hairTypesProbabilityDistribution[b] ? a : b);
    return hairType.toLowerCase()
}

function getHairColor(hairColorProbabilityDistribution){
    const hairColor = Object.keys(hairColorProbabilityDistribution).reduce(
        (a, b) => hairColorProbabilityDistribution[a] > hairColorProbabilityDistribution[b] ? a : b);
    return hairColor.toLowerCase()
}

function getRecommendedConcern(params){    
    return "damage";
  
    let recommendation = undefined;
    
    var attr = params.attributes;
    
    const hairType = getHairType(params.hairstyle);
    const hairColor = getHairType(params.haircolor);
    
    const concern_keys = ["Dryness", "Frizz", "Split Ends", "damage"];
    var biggestConcern = getMaxNonZeroHairCondition(params, concern_keys);

    if(hairType == "curly" || hairType == "kinky"){
        recommendation = "curly";
    }
    else if(hairColor == "blond"){
        recommendation = "blond";
    }
    else if(biggestConcern != undefined){
        recommendation = biggestConcern;
    }
    else if(getAttributeScore(attr, "Shine", 0)<1){
        recommendation = "Shine";
    }
    else{
        recommendation = "Default";
    }
    return recommendation;
}

function getMaxNonZeroHairCondition(params, keys){
    var maxValue = 0;
    var maxKey;
    var attributes = params.attributes;
    for (var i = 0; i < keys.length; i++) {
        if(keys[i]=="damage"){
            if(getAttributeScore(params,keys[i],0)>maxValue){
                maxValue = getAttributeScore(params,keys[i],0);
                maxKey = keys[i];
            }
        }
        else{
            if(getAttributeScore(attributes,keys[i],0)>maxValue){
                maxValue = getAttributeScore(attributes,keys[i],0);
                maxKey = keys[i];
            }
        }
    }
    return maxKey;
}
  
function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

function showProductsRecommendation(response){
    const tangent_recommended_products = response.products;
    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    const tangent_product_sections = response.product_sections;
    const tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
        createProductSection(tangent_product_sections, tangent_text_sections);
    }    
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }

    if (tangent_recommended_products.length > 0) {
        setProductsToView(tangent_recommended_products, tangent_product_sections, response.selected_variants);
        enableButtonListener();
        loadElementsOnResponseData(); 
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
}

function setProductsToView(products, sections, selected_variants) {
  tangent_selected_product_map = {};
  let stepCount=1;
  Object.keys(sections).forEach(section => {
    const product_ids = sections[section];
    const product_section_grid = document.getElementById(section + "_product_grid");

    // Create a document fragment for improved performance
    const fragment = document.createDocumentFragment();

    for (const id of product_ids) {
       
      for (let p = 0; p < products.length; p++) {
        // Find product by ID
        if (String(products[p].id) === id) {
          const product = products[p];
          
          const variant = getSelectedVariant(product, selected_variants[product.id]);
          // Track selected product variant
          tangent_selected_product_map[product.id] = extractVariantId(variant.id);
          
          // Generate product HTML and append it to the fragment
          const product_html = getProductHTML(product, p, variant, section, sections, stepCount);
          if(product_html){
            stepCount++;
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = product_html;

            // Append the created product HTML to the fragment
            while (tempDiv.firstChild) {
              fragment.appendChild(tempDiv.firstChild);
            }
          }
        }
      }
    }

    // Append the fragment to the DOM in one go
    product_section_grid.appendChild(fragment);
  });
}

function extractVariantId(variantId) {
  return variantId.replace("gid://shopify/ProductVariant/", "");
}

function getSelectedVariant(product, variant_list) {
  const productVariants = product.variants.edges || [];
  
  if (productVariants.length === 0) {
    throw new Error("No variants available for the product.");
  }
  
  if (variant_list.length > 0) {
    const selectedVariantId = Number(variant_list[0]);
    return productVariants.find(variant => extractVariantId(variant.node.id) === selectedVariantId) || productVariants[0].node;
  }
  
  return productVariants[0].node;
}

function getProductHTML(product, index, variant, section, sections, stepCount) {
    const variantId = extractVariantId(variant.id);
    // Setting default / first variant data
    const variant_image_url = getVariantImage(variant, product);
    const variant_product_url = `${product.onlineStoreUrl}?variant=${variantId}`;
    let buttonClass="";
    let buttonText = default_addToCartText;

    const productMiniDescription = getProductMiniDescription(product);

    const reviewRatingHtml = getStarRatingHTML(product);

    if(isProductAvailable(product, variant)){
        updateSectionAllToCartLink(sections, product.id, tangent_selected_product_map[product.id], section);
    }
    else{
        buttonText = out_of_stock_text;
        buttonClass ="disable-button";
    }
    
    // Product View HTML using template literals
    const product_html = `
      <div>
        <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variant_product_url}">
          <p>Step ${stepCount}</p>
          <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
          ${reviewRatingHtml}
          <h3 class="tangent-product-title tangent_product_title_text product-card-title">${product.title}</h3>
          ${productMiniDescription}
          <p id="price_tangent_product_${index}" class="tangent_product_price_text">${tangent_client_domain_currency}${variant.price}</p>
        </a>
        <button class="tangent-product-add-btn-wrapper tangent_add_to_cart_button ${buttonClass}" id="${variantId}" data-section="${section}">${buttonText}</button>
      </div>
    `;
    return product_html;
}

function getProductMiniDescription(product) {
  const desc = product?.product_subtitle?.value;
  return desc ? `<p class="product-description">${desc}</p>` : '';
}

function isProductAvailable(product, variant){
  // Check if the product is active
  if (product.status.toLowerCase() !== "active") {
      return false;
  }
  return variant.availableForSale;
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections, product_id, vid) {
    if (!product_sections) return;

    for (const section in product_sections) {
        if (product_sections[section].includes(String(product_id))) {
            // Initialize section if it doesn't exist
            if (!sections_add_to_cart_map[section]) {
                sections_add_to_cart_map[section] = {
                    count: 0,
                    cart_link: tangent_client_domain_url + "/cart/add?",
                    list: []
                };
            }

            // Update section if vid is not already included
            const sectionData = sections_add_to_cart_map[section];
            if (!sectionData.list.includes(vid)) {
                sectionData.count++;
                sectionData.cart_link += `&id[]=${vid}`;
                sectionData.list.push(vid);

                // Show "Add All to Cart" button if more than one product
                const addAllButton = document.getElementById(`${section}`);
                if (addAllButton) {
                    addAllButton.style.display = sectionData.count > 1 ? "block" : "none";
                }
            }
        }
    }
}

const getVariantImage = (variant, product) => {
  if(variant.image?.url){
    return variant.image.url; 
  }
  else{
    return product.images.nodes[0].url
  }
  return 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
}

function createFormDataFromIds(idArray, element) {
  const section = element.getAttribute('data-section');
  if (element.getAttribute('data-planid')) {
    return {
      items: idArray.map(id => ({
        id: id,
        quantity: 1,
        selling_plan: element.getAttribute('data-planid')
      }))
    };
  }

  const items = idArray.map(id => {
    const baseItem = { id, quantity: 1 };

    if (section === "section_advanced") {
      baseItem.properties = {
        _type: "tangent-advanced-product",
        _variantIds: idArray
      };
    }
    return baseItem;
  });
  return { items };
}

function addToCart(element){ 
  const formData = createFormDataFromIds([extractVariantId(element.id)],element);
  addToCartApi(formData, element);
}

// Add all to cart function for sections
function addAllTocartFunction(element) {
  const formData = createFormDataFromIds(sections_add_to_cart_map[element.id].list, element);
  if(formData){
    addToCartApi(formData, element);
  } 
  else {
      var x = document.querySelector("#message-text");
      x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
      x.className = "show";
      setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
  }
}

function addToCartApi(payload, element){

  element.innerHTML = `<div class="loader button-loader">&nbsp;</div>`
  fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
  }).then(() => {
    element.innerHTML = default_addedToCartText;
    element.classList.add("added-to-cart-style"); 
    var drawer = document.querySelector("cart-drawer"); 
    drawer.fullUpdate().then(() => { 
    drawer.open(); }); 
  }).catch((error) => {
      console.error('Error:', error);
  });
}


function createSectionContainer(section_name) {
  const containerId = `${section_name}_container`;

  const container = document.createElement("div");
  container.id = containerId;

  // Base class (useful for styling/hooks)
  container.className = `section_container ${section_name}_container`;

  // Helpful for debugging / targeting
  container.dataset.section = section_name;

  return container;
}

function createSectionAddAllToCart(section_name) {
  // Wrapper
  const container = document.createElement("div");
  container.className = "section_add_all_wrapper";

  // Button
  const btn = document.createElement("button");

  btn.id = section_name;
  btn.className = `section_add_all_to_cart ${section_name}_add_all_to_cart btn`;
  btn.textContent = default_add_all_to_cart_text;

  btn.dataset.section = section_name;

  btn.addEventListener("click", (e) => {
    addAllTocartFunction(e.currentTarget);
  });

  // Text below button
  const text = document.createElement("p");
  text.className = "section_add_all_text";
  text.innerHTML = '<p>Use code <b>QUIZ10</b> to take <b>10% off</b> your order</p>';

  // Append
  container.appendChild(btn);
  container.appendChild(text);

  return container;
}

function addSectionProductGridContainer(section_name) {
  const container = document.createElement("div");

  container.id = `${section_name}_product_grid`;
  container.className = `section_product_grid ${section_name}_product_grid`;

  return container;
}

function getTabTitle(section) {
  return tabs_title_mapping?.[section] 
    || section
        .replace(/^section_/, '')
        .replace(/_/g, ' ')
        .toUpperCase();
}

function createProductSection(product_sections, text_sections = {}) {
  for (const section_name in product_sections) {

    const products = product_sections[section_name];
    if (!products || !products.length) continue;

    // Prevent duplicate render
    if (document.getElementById(`${section_name}_container`)) continue;

    const section_container = createSectionContainer(section_name);

    // Add text section (if exists)
    if (text_sections?.[section_name]) {
      createTextSectionBeforeProducts(text_sections, section_container, section_name);
    }

    // Product grid
    const productGrid = addSectionProductGridContainer(section_name);
    if (productGrid) section_container.appendChild(productGrid);

    // Add all to cart button
    const addAllBtn = createSectionAddAllToCart(section_name);
    if (addAllBtn) section_container.appendChild(addAllBtn);

    // Append to main wrapper
    tangent_sections_wrapper_element?.appendChild(section_container);
  }
}

function createTextSectionBeforeProducts(text_sections, section_container, section_name) {
  const content = text_sections?.[section_name];

  if (Array.isArray(content) && content.length) {
    const sectionDiv = document.createElement("div");
    sectionDiv.id = `${section_name}_text_container`;
    sectionDiv.className = `section_text_container ${section_name}_text_container`;

    // If content is safe HTML, keep innerHTML. Otherwise switch to textContent.
    sectionDiv.innerHTML = content.join(' ');

    section_container.appendChild(sectionDiv);
  }
}

function createTextSection(product_sections, text_sections) {
  for (const section_name in text_sections) {

    // Skip if product section exists
    if (section_name in product_sections) continue;

    const content = text_sections[section_name];
    if (!Array.isArray(content) || !content.length) continue;

    // Prevent duplicate render
    if (document.getElementById(`${section_name}_text_container`)) continue;

    const section_container = createSectionContainer(section_name);

    const section_div = document.createElement("div");
    section_div.id = `${section_name}_text_container`;
    section_div.className = `section_text_container ${section_name}_text_container`;

    section_div.innerHTML = content.join(' ');

    section_container.appendChild(section_div);

    // Placement logic
    let targetParent = tangent_sections_wrapper_element;

    if (section_name === "section_selfie") {
      targetParent = document.querySelector("#section_selfie_container_parent");
    } else if (section_name === "section_dosha") {
      targetParent = document.querySelector("#section_dosha_container");
    }

    targetParent?.appendChild(section_container);
  }
}

// Handle Tab button selection
// function switchTab(element) {
//   let i, tabcontent, tablinks;

//   // This is to clear the previous clicked content.
//   tabcontent = document.querySelectorAll(".tabcontent");
//   for (i = 0; i < tabcontent.length; i++) {
//     tabcontent[i].style.display = "none";
//   }
  
//   tablinks = document.querySelectorAll(".tablinks");
//   for (i = 0; i < tablinks.length; i++) {
//     tablinks[i].className = tablinks[i].className.replace(" active", "");
//   }

//   // Display the clicked tab and set it to active.
//   document.getElementById(element.name+"_container").style.display = "flex";
//   document.getElementById(element.name+"_tab_button").classList.add("active");
// }

function enableButtonListener() {
  const buttons = document.querySelectorAll(
    '.tangent-product-add-btn-wrapper, .tangent-product-add-btn-wrapper-subscribe'
  );

  buttons.forEach(btn => {
    // Prevent duplicate listeners
    if (!btn.dataset.listenerAdded) {
      btn.addEventListener('click', () => addToCart(btn));
      btn.dataset.listenerAdded = "true";
    }
  });
}

function loadElementsOnResponseData() {
  document.querySelectorAll('.load-on-data').forEach(el => {
    el.style.display = 'block';
  });
}

// Hide loading
function hideLoading() {
  document.querySelector("#loading-section")?.classList.add('hidden');
}

function getStarRatingHTML(product) {
    if (!product?.average_reviews) return '';

    const rating = Number(product.average_reviews.value);
    const count = Number(product?.reviews_count?.value || 0) + " reviews";

    if (
        rating == null ||
        rating === '' ||
        isNaN(rating) ||
        rating < 0 || rating > 5
    ) {
        return '';
    }

    const percentage = (rating / 5) * 100;

    return `
        <div class="rating-container">
            <svg height="18" viewBox="0 0 82.33333333333333 14">
                
                <defs>
                    <mask id="star-mask">
                        <rect x="0" y="0" width="${percentage}%" height="100%" fill="white"></rect>
                    </mask>
                </defs>

                <!-- Empty stars -->
                <g opacity="0.3">
                    <use x="0" href="#oke-star-filled"></use>
                    <use x="16.933333333333334" href="#oke-star-filled"></use>
                    <use x="33.86666666666667" href="#oke-star-filled"></use>
                    <use x="50.8" href="#oke-star-filled"></use>
                    <use x="67.73333333333333" href="#oke-star-filled"></use>
                </g>

                <!-- Filled portion -->
                <g mask="url(#star-mask)">
                    <use x="0" href="#oke-star-filled"></use>
                    <use x="16.933333333333334" href="#oke-star-filled"></use>
                    <use x="33.86666666666667" href="#oke-star-filled"></use>
                    <use x="50.8" href="#oke-star-filled"></use>
                    <use x="67.73333333333333" href="#oke-star-filled"></use>
                </g>

            </svg>

            <span class="rating-count">${count}</span>
        </div>
    `;
}

class TangentSelfie {
    canvas;
	constructor(imgId){
		this.img = document.getElementById(imgId);
	}

	async init() {
      try{
        // Handle the case if the image is not loaded yet
        const result = await this.imageLoad(this.img);
        await this.sleep(2000); 
        this.imageWidth = this.img.clientWidth;
        this.imageHeight = this.img.clientHeight;
      } catch(e){
        console.log(e);
      }
	}

	async imageLoad(imgElem) {
	    return new Promise(res => {
	        if (imgElem.complete) {
	            return res();
	        }
	        imgElem.onload = () => res();
	        imgElem.onerror = () => res();
	    });
	}

	async sleep(ms) {
	    return new Promise(resolve => setTimeout(resolve, ms));
	}

	get imgWidth(){
		return this.imageWidth
	}

	get imgHeight(){
		return this.imageHeight
	}

  scaleCanvas(canvas){
		var ctx = canvas.getContext("2d");
		ctx.resetTransform();
		ctx.scale(canvas.width/this.img.naturalWidth, canvas.height/this.img.naturalHeight);
        ctx.translate(0.5, 0.5);
  }

	drawRectangleOnCanvas(canvas, rectanglePoints, style){
		this.scaleCanvas(canvas)
		var ctx = canvas.getContext("2d");
        
        ctx.lineWidth = 10;
        ctx.strokeStyle = style['color'];
		
        ctx.beginPath();
		ctx.rect(rectanglePoints[0]._x, rectanglePoints[0]._y, rectanglePoints[1]._x - rectanglePoints[0]._x, rectanglePoints[1]._y - rectanglePoints[0]._y);

        ctx.fillStyle = style['fillColor'];
		ctx.fill();
		ctx.stroke();
	}

    getScaledBox(containerDiv, box){
        const [[left_x, top_y], [right_x, bottom_y]] = box
        const viewWidth = containerDiv.getBoundingClientRect().width
        const viewHeight = containerDiv.getBoundingClientRect().height
        
        return [
            [(left_x*viewWidth)/this.img.naturalWidth, (top_y*viewHeight)/this.img.naturalHeight], 
            [(right_x*viewWidth)/this.img.naturalWidth, (bottom_y*viewHeight)/this.img.naturalHeight]
        ]
    }

    drawRectangleUsingHtml(containerDiv, attributeName, box, handleHairAttributeClick = null){
        let div = this.getAttributeBoxDiv(containerDiv, attributeName, box)
        // let span = this.getAttributeNameSpan(attributeName)
        // div.appendChild(span);
        containerDiv.appendChild(div);
        if(handleHairAttributeClick){
            div.addEventListener("click", (event) => handleHairAttributeClick(event, attributeName))
        }
    }
    
    getAttributeBoxDiv(containerDiv, attributeName, box){
        // if(attributeName == "Flyaways") attributeName = "Frizz";
        const [[left_x, top_y], [right_x, bottom_y]] = this.getScaledBox(containerDiv, box)
    
        var div = document.createElement('div');
        div.className = 'attributes-overlay';
        div.style.top = top_y + 'px';
        div.style.left = left_x + 'px';
        div.style.width = (right_x - left_x) + 'px';
        div.style.height = (bottom_y - top_y) + 'px';
        div.style.borderColor = attributeStyle[attributeName]['color'];
        div.style.backgroundColor = attributeStyle[attributeName]['fillColor'];
    
        return div;
    }
    
    getAttributeNameSpan(attributeName){
        var span = document.createElement('span');
        span.className = 'attribute-text';
        span.style.backgroundColor = attributeStyle[attributeName]['color']
        span.innerHTML = attributeName;
    
        return span;
    }

}

const canvas = document.getElementById('selfie_canvas');
const overlays_container_div = document.getElementById('attributes-overlay-container');
let selfie = new TangentSelfie('selfie_img');
  